import React from 'react';
import PropTypes from 'prop-types';

import { ContentZonesService } from '@sm360/widget-commons-core-services';
import InformationZoneElement from 'login/components/Library/InformationZone/InformationZoneElement.jsx';

import 'login/components/Library/InformationZone/InformationZone.scss';

class InformationZone extends React.PureComponent {
    renderImageInformation() {
        return (
            <div className="information-image">
                <img src={this.props.czOldImage} alt="oldImage" />
            </div>
        );
    }

    renderTextInformation() {
        const mainSubTitle =
            ContentZonesService.getContentZone(this.props.groupName, 'mainSubTitle') &&
            ContentZonesService.getContentZone(this.props.groupName, 'mainSubTitle').getValue();
        const mainTitle =
            ContentZonesService.getContentZone(this.props.groupName, 'mainTitle') &&
            ContentZonesService.getContentZone(this.props.groupName, 'mainTitle').getValue();

        const firstImage =
            ContentZonesService.getContentZone(this.props.groupName, 'firstImage') &&
            ContentZonesService.getContentZone(this.props.groupName, 'firstImage').getValue();
        const firstTitle =
            ContentZonesService.getContentZone(this.props.groupName, 'firstTitle') &&
            ContentZonesService.getContentZone(this.props.groupName, 'firstTitle').getValue();
        const firstSubTitle =
            ContentZonesService.getContentZone(this.props.groupName, 'firstSubTitle') &&
            ContentZonesService.getContentZone(this.props.groupName, 'firstSubTitle').getValue();

        const secondImage =
            ContentZonesService.getContentZone(this.props.groupName, 'secondImage') &&
            ContentZonesService.getContentZone(this.props.groupName, 'secondImage').getValue();
        const secondTitle =
            ContentZonesService.getContentZone(this.props.groupName, 'secondTitle') &&
            ContentZonesService.getContentZone(this.props.groupName, 'secondTitle').getValue();
        const secondSubTitle =
            ContentZonesService.getContentZone(this.props.groupName, 'secondSubTitle') &&
            ContentZonesService.getContentZone(this.props.groupName, 'secondSubTitle').getValue();

        const thirdImage =
            ContentZonesService.getContentZone(this.props.groupName, 'thirdImage') &&
            ContentZonesService.getContentZone(this.props.groupName, 'thirdImage').getValue();
        const thirdTitle =
            ContentZonesService.getContentZone(this.props.groupName, 'thirdTitle') &&
            ContentZonesService.getContentZone(this.props.groupName, 'thirdTitle').getValue();
        const thirdSubTitle =
            ContentZonesService.getContentZone(this.props.groupName, 'thirdSubTitle') &&
            ContentZonesService.getContentZone(this.props.groupName, 'thirdSubTitle').getValue();

        return (
            <div className="information-text">
                <div className="main-information">
                    <div className="main-information--subtitle">{mainSubTitle}</div>
                    <div className="main-information--title">{mainTitle}</div>
                </div>
                <div className="elements-information">
                    {firstImage &&
                        firstTitle &&
                        firstSubTitle && (
                            <InformationZoneElement image={firstImage} title={firstTitle} subtitle={firstSubTitle} />
                        )}
                    {secondImage &&
                        secondTitle &&
                        secondSubTitle && (
                            <InformationZoneElement image={secondImage} title={secondTitle} subtitle={secondSubTitle} />
                        )}
                    {thirdImage &&
                        thirdTitle &&
                        thirdSubTitle && (
                            <InformationZoneElement image={thirdImage} title={thirdTitle} subtitle={thirdSubTitle} />
                        )}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="information-zone">
                {this.props.czOldImage ? this.renderImageInformation() : this.renderTextInformation()}
            </div>
        );
    }
}

InformationZone.defaultProps = {
    czOldImage: '',
};

InformationZone.propTypes = {
    groupName: PropTypes.string.isRequired,
    // TODO : On utilise une CZ image (celle qui était utilisé pour accompagner le signup)
    // pour les anciens sites qui n'ont pas encore configuré les nouvelles CZ Text
    czOldImage: PropTypes.string,
};

InformationZone.displayName = 'InformationZone';

export default InformationZone;
